__turbopack_context__.v({
  "calendar": "DatePicker-module__cx7YlG__calendar",
  "calendarHeader": "DatePicker-module__cx7YlG__calendarHeader",
  "container": "DatePicker-module__cx7YlG__container",
  "container__fullWidth": "DatePicker-module__cx7YlG__container__fullWidth",
  "day": "DatePicker-module__cx7YlG__day",
  "day__otherMonth": "DatePicker-module__cx7YlG__day__otherMonth",
  "day__selected": "DatePicker-module__cx7YlG__day__selected",
  "day__today": "DatePicker-module__cx7YlG__day__today",
  "daysGrid": "DatePicker-module__cx7YlG__daysGrid",
  "iconWrapper": "DatePicker-module__cx7YlG__iconWrapper",
  "input": "DatePicker-module__cx7YlG__input",
  "inputWrapper": "DatePicker-module__cx7YlG__inputWrapper",
  "input__error": "DatePicker-module__cx7YlG__input__error",
  "label": "DatePicker-module__cx7YlG__label",
  "message": "DatePicker-module__cx7YlG__message",
  "message__error": "DatePicker-module__cx7YlG__message__error",
  "monthYear": "DatePicker-module__cx7YlG__monthYear",
  "navButton": "DatePicker-module__cx7YlG__navButton",
  "weekDay": "DatePicker-module__cx7YlG__weekDay",
  "weekDays": "DatePicker-module__cx7YlG__weekDays",
});
